module.exports = __webpack_public_path__ + "static/media/VendPin_Circle.df4777d3.png";